import { Contract as EthCallContract } from 'ethcall';
import { ethers } from 'ethers';
import ERC20ABI from './bitly/abi/contracts/tests/ERC20.sol/ERC20Token.json';
import BTLYABI from './bitly/abi/contracts/BTLY.sol/BTLY.json';
import BankABI from './bitly/abi/contracts/Bank.sol/Bank.json';
import BitlyExchangeABI from './bitly/abi/contracts/BitlyExchange.sol/BitlyExchange.json';
import LPABI from './bitly/abi/contracts/LP.sol/LP.json';
import IZiSwapPoolABI from './iziswap/abi/contracts/iZiSwapPool.sol/iZiSwapPool.json';
import { ADDRESSES } from './constants';
import { ERC20__factory, BTLY__factory, Bank__factory, BitlyExchange__factory, LP__factory } from './bitly/typechain-types';
import { IZiSwapPool__factory, } from './iziswap/typechain-types';
export * from './defines';
export const getPairContractMulticall = (marketAddress) => new EthCallContract(marketAddress, LPABI);
export const getPairContract = (marketAddress, provider) => LP__factory.connect(marketAddress, provider);
export const getPairContractInterface = () => new ethers.utils.Interface(LPABI);
export const getTokenContractMulticall = (tokenAddress) => new EthCallContract(tokenAddress, ERC20ABI);
export const getCoreContractMulticall = (coreAddress) => new EthCallContract(coreAddress, IZiSwapPoolABI);
export const getTokenContract = (tokenAddress, provider) => ERC20__factory.connect(tokenAddress, provider);
export const getCoreContract = (coreAddress, provider) => IZiSwapPool__factory.connect(coreAddress, provider);
export const getCoreContractInterface = () => new ethers.utils.Interface(IZiSwapPoolABI);
export const getContractsByNetwork = (networkId, provider) => {
    return {
        Exchange: (ADDRESSES.EXCHANGE[networkId.toString()]
            ? BitlyExchange__factory.connect(ADDRESSES.EXCHANGE[networkId.toString()], provider)
            : undefined),
        BitlyBank: (ADDRESSES.BANK[networkId.toString()]
            ? Bank__factory.connect(ADDRESSES.BANK[networkId.toString()], provider)
            : undefined),
        BTLYToken: (ADDRESSES.BTLY[networkId.toString()]
            ? BTLY__factory.connect(ADDRESSES.BTLY[networkId.toString()], provider)
            : undefined),
    };
};
export const getMulticallContractsByNetwork = (networkId) => {
    return {
        Exchange: ADDRESSES.EXCHANGE[networkId.toString()]
            ? new EthCallContract(ADDRESSES.EXCHANGE[networkId.toString()], BitlyExchangeABI)
            : undefined,
        BitlyBank: ADDRESSES.BANK[networkId.toString()]
            ? new EthCallContract(ADDRESSES.BANK[networkId.toString()], BankABI)
            : undefined,
        BTLYToken: ADDRESSES.BTLY[networkId.toString()]
            ? new EthCallContract(ADDRESSES.BTLY[networkId.toString()], BTLYABI)
            : undefined,
    };
};
export * from './constants';
